import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('app', ['newHeaderExchangeUrl']),
    exchangeNavigateUrl() {
      return `${this.newHeaderExchangeUrl}?welcome=true`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-header/app-header-external-nav.js